import { useTranslation } from 'react-i18next';
import env from '@/env';
import { useTeamNavigationItems } from './subNavigation/useTeamNavigationItems';
import { useTeamDashboardNavigation } from './useTeamDashboardNavigation';

export const TEAM_BASE_ROUTE = `https://${env.VITE_IQ_DOMAIN}/team`;

export const useTeamNavigationItem = () => {
  const { t } = useTranslation('navigation');
  const teamDashboardRoute = useTeamDashboardNavigation();

  return {
    id: 'team',
    icon: 'TeamSoccer' as const,
    path: teamDashboardRoute,
    label: t('crossPlatform.primary.teams'),
    subNav: useTeamNavigationItems(),
  };
};
